import * as z from "zod";
import { requiredString } from "components/form/utils";

export const tagsSchema = z.object({
  label: requiredString(),
  color: requiredString(),
  for: z.optional(z.string()).default("timesheet"),
});
